import { render } from "./PortalAuthentication.vue?vue&type=template&id=bbaa4302"
import script from "./PortalAuthentication.vue?vue&type=script&lang=js"
export * from "./PortalAuthentication.vue?vue&type=script&lang=js"

import exportComponent from "/runner/_work/cb-checkout/cb-checkout/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__